import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { RefTypeRepository } from '../../../../store/ref-type-state/ref-type-state.repository';

interface getRefTypeDataTableStructureProps {
  store: RefTypeRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getRefTypeDataTableStructure = ({ store, createAction, rowActions }: getRefTypeDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refType.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const descriptionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.refType.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'settings.refType.table.singular',
    plural: 'settings.refType.table.plural',
    data: [],
    columns: [idColumn, descriptionColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('response', row);
      store.set('dto', row);
    },
    createAction,
    rowActions,
    searchableFields: ['id', 'description'],
  };
};
